import React from 'react';
import ControlsStyled from './bundle.esm2.js';
import Clickable from '../../Clickable/bundle.esm.js';
import ArrowLeftSVG from '../../../assets/images/carousel/bundle.esm.js';
import ArrowRightSVG from '../../../assets/images/carousel/bundle.esm2.js';

const Controls = (props) => {
  const { prevIcon, nextIcon, snapTo, currentSlide, infinite } = props;
  const { numberOfSlides } = props;
  const snapToLeft = (e) => {
    e.stopPropagation();
    if (currentSlide === 1) {
      if (!infinite)
        return;
      snapTo(numberOfSlides);
      return;
    }
    snapTo(currentSlide - 1);
  };
  const snapToRight = (e) => {
    e.stopPropagation();
    if (currentSlide === numberOfSlides) {
      if (!infinite)
        return;
      snapTo(1);
      return;
    }
    snapTo(currentSlide + 1);
  };
  if (numberOfSlides === 1)
    return null;
  return /* @__PURE__ */ React.createElement(ControlsStyled, {
    className: "Controls"
  }, /* @__PURE__ */ React.createElement(Clickable, {
    className: "Controls__arrow Controls__arrow--left",
    onClick: snapToLeft
  }, prevIcon != null ? prevIcon : /* @__PURE__ */ React.createElement(ArrowLeftSVG, {
    className: "Controls__icon"
  })), /* @__PURE__ */ React.createElement(Clickable, {
    className: "Controls__arrow Controls__arrow--right",
    onClick: snapToRight
  }, nextIcon != null ? nextIcon : /* @__PURE__ */ React.createElement(ArrowRightSVG, {
    className: "Controls__icon"
  })));
};
Controls.defaultProps = {};

export { Controls as default };
//# sourceMappingURL=bundle.esm.js.map
